<template>
  <ProfilesSelectField v-model="context.value.value" v-bind="props" />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import ProfilesSelectField from '@/apps/admin/components/group/ProfilesSelectField.vue'

import { SchemaFormKitProps } from './types'
const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
